import { __assign } from "tslib";
import React from "react";
import { BaseTransition } from "../transition/BaseTransition";
import { hashObject } from "../_util/hash-object";
import { insertCSS } from "../_util/insert-css";
var rootId = "tea-message-root";
export function getRoot(classPrefix) {
    var root = window[rootId] || document.getElementById(rootId);
    if (!root) {
        root = document.createElement("div");
        root.id = rootId;
        document.body.appendChild(root);
        window[rootId] = root;
    }
    return root;
}
var maxCountLimit = 1;
var listKey = "tea-message-list-identification";
export function limit(notice) {
    if (!window[listKey]) {
        window[listKey] = [];
    }
    if (window[listKey].length >= maxCountLimit) {
        try {
            window[listKey][0].hide();
            window[listKey].shift();
        }
        catch (_) {
            // hide failed
        }
    }
    window[listKey].push(notice);
}
export function MessageTransition(props) {
    return React.createElement(BaseTransition, __assign({}, transition(), props));
}
var generateCSS = function (transition) { return "\n." + transition.classNames + "-enter {\n  opacity: 0 !important;\n  transform: translate3d(-50%, 0, 0);\n}\n." + transition.classNames + "-enter-active {\n  opacity: 1 !important;\n  transform: translate3d(-50%, 0, 0);\n  transition: opacity " + transition.timeout.enter + "ms ease,\n    transform " + transition.timeout.enter + "ms ease;\n}\n." + transition.classNames + "-exit {\n  opacity: 1 !important;\n}\n." + transition.classNames + "-exit-active {\n  opacity: 0 !important;\n  transition: opacity " + transition.timeout.enter + "ms ease;\n}\n"; };
var setupTransitions = {};
export function transition(enterTimeout, leaveTimeout) {
    if (enterTimeout === void 0) { enterTimeout = 300; }
    if (leaveTimeout === void 0) { leaveTimeout = 300; }
    var name = "tea-transition-notification";
    var hash = hashObject({ name: name, enterTimeout: enterTimeout, leaveTimeout: leaveTimeout });
    if (!setupTransitions[hash]) {
        setupTransitions[hash] = {
            classNames: name + hash,
            timeout: {
                enter: enterTimeout,
                exit: leaveTimeout,
            },
            unmountOnExit: true,
            mountOnEnter: true,
        };
        var transition_1 = setupTransitions[hash];
        var css = generateCSS(transition_1);
        insertCSS(name + hash, css);
    }
    return setupTransitions[hash];
}
//# sourceMappingURL=util.js.map